<div class="p-d-flex p-flex-column p-p-2">
  <!-- Header-->
  <div class="p-d-flex p-justify-between p-ai-center">
    <div class="p-d-flex p-flex-column">
      <h2>Pretplata</h2>
      <div>Upravljajte vašim paketima i računima</div>
    </div>
<!--    <kodit-button-->
<!--      btnLabel="Dodaj paket"-->
<!--    ></kodit-button>-->
  </div>
  <div *ngIf="isTrial" class="trial-container p-d-flex p-flex-row p-p-3 p-justify-between p-align-center p-mt-2">
    <div class="p-d-flex p-flex-column">
      <div class="trial-title">Probni period je aktivan</div>
      <div class="p-mt-3 trial-subtitle">Preostalo vam je {{ subDaysLeft }} dan(a) probnog perioda. Nadogradite
        sada
        da
        nastavite sa korišćenjem svih funkcija.
      </div>
    </div>
    <kodit-button
      btnSeverity="p-button-warning"
      btnLabel="Nadogradi"
      (btnClicked)="goToPaketi()"
    ></kodit-button>
  </div>
  <!-- Packages-->
  <div class="p-mt-4 k-card" [ngClass]="subExpired ? 'centered' : ''">
    <div *ngIf="subExpired">Nema aktivnih paketa</div>
    <div *ngIf="!subExpired && packages && packages.length > 0" class="p-d-flex p-flex-column">
      <div class="p-d-flex p-ai-center">
        <img
          src="assets/icons/crown.svg"
          width="17"
          height="17"
          alt="crown-img"
        />
        <div class=" p-ml-2 p-text-bold">Aktivni paketi</div>
      </div>
      <div class="p-mt-3 p-d-flex p-ai-center gap-12">
        <div *ngFor="let p of getMainPackages()" class="main-package-card p-d-flex p-ai-center p-justify-between">
          <div class="p-d-flex p-ai-center">
            <div class="p-d-flex p-ai-center p-justify-center main-package-icon">
              <img
                [src]="'assets/icons/' + p.icon"
                width="17"
                height="17"
                alt="crown-img"
              />
            </div>
            <div class="p-ml-2 p-d-flex p-flex-column">
              <div class="p-text-bold">{{p.name}}</div>
              <div >Ističe: {{expires}}</div>
            </div>
          </div>
          <div class="p-d-flex p-flex-column p-ai-center">
            <div class="p-text-bold">{{p.price}} {{getPriceUnit(p.priceLabel)}}</div>
            <div class="p-d-flex p-justify-end price-period">/{{getPriceUnitPeriod(p.priceLabel)}}</div>
          </div>
        </div>
      </div>
      <kodit-divider></kodit-divider>
      <div class="p-d-flex p-ai-center">
        <div>Dodatni paketi</div>
      </div>
      <div class="p-mt-2 p-d-flex p-ai-center gap-12">
        <div *ngFor="let p of getAdditionalPackages()" class="main-package-card p-d-flex p-ai-center">
          <img
            [src]="'assets/icons/' + p.icon"
            width="17"
            height="17"
            alt="crown-img"
          />
          <div class="p-ml-1 p-text-bold">
            {{p.name}} - {{p.price}} {{p.priceLabel}}
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Placanja-->
  <div class="p-mt-4 k-card">
    <kodit-placanja-tables></kodit-placanja-tables>
  </div>
</div>
